/**
 * Frequently bought together: fix prev/next disabled state for peek / partial-slide
 * layouts. Native SliderComponent uses full-slide visibility; this runs after it
 * (requestAnimationFrame) and sets disabled from scroll edges only.
 */
(function () {
  function syncNav(root) {
    var track = root.querySelector('[id^="Slider-"]');
    var prev = root.querySelector('button[name="previous"]');
    var next = root.querySelector('button[name="next"]');
    if (!track || !prev || !next) return;

    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    var left = track.scrollLeft;

    if (left <= 1) prev.setAttribute('disabled', 'disabled');
    else prev.removeAttribute('disabled');

    if (maxScroll <= 1 || left >= maxScroll - 1) next.setAttribute('disabled', 'disabled');
    else next.removeAttribute('disabled');
  }

  function bind(root) {
    var track = root.querySelector('[id^="Slider-"]');
    if (!track || root.dataset.fbtNavBound === 'true') return;
    root.dataset.fbtNavBound = 'true';

    function scheduleSync() {
      requestAnimationFrame(function () {
        syncNav(root);
      });
    }

    track.addEventListener('scroll', scheduleSync, { passive: true });
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(scheduleSync).observe(track);
    }
    scheduleSync();
  }

  function scan(container) {
    var scope = container && container.querySelectorAll ? container : document;
    var roots = scope.querySelectorAll
      ? scope.querySelectorAll('.fbt-products slider-component')
      : [];
    for (var i = 0; i < roots.length; i++) bind(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector) {
      scan(event.target);
    }
  });
})();
